"use client"

import { filterSeasonalMerchandiseProductsByVariantDisplays } from "@/app/(site)/_utils/seasonalMerchandising"
import { type Locale } from "@/i18n/locales"
import depictClientOnlyClient from "@/lib/depict-client/depict-client-only-client-init"
import { formatDepictPrices } from "@/lib/depict-client/helpers/depict-transforms"
import { type RecommendRequestV3 } from "@/lib/depict-client/types/api/RecommendRequestV3"
import logger from "@/lib/logger/logger-init"
import { match } from "ts-pattern"

//@todo: when going over to SSR rendered recommendedProducts from depict we need a ssr only version of this function

/**
 * Bucket A migration: dropped the `getBasketSessionFromCookiesClient()` fetch.
 * `formatDepictPrices` accepts `currentPricelist: CurrencyFormat | undefined`
 * and falls back to per-variant `currency` for the suffix and sensible defaults
 * for prefix/separators (see `lib/depict-client/helpers/formatPrice.ts`). For
 * active-basket users the eventual price-format polish lives at the SWR layer
 * (Phase 4) — fetching the cookie here is a waterfall this Bucket A consumer
 * shouldn't pay.
 */
export const getDepictRecommendedProductsClient = async (
    req: RecommendRequestV3,
    paramsLocale: Locale
) => {
    const response = await depictClientOnlyClient.recommendations.getProducts({
        market: req.market,
        locale: req.locale,
        type: req.type,
        product_ids: req.product_ids,
        limit: req.limit,
        session_id: req.session_id
    })
    return match(response)
        .with({ success: true }, async data => {
            const transformedDataWithFormattedPrices = formatDepictPrices(
                data.data,
                undefined
            )

            if (paramsLocale) {
                const filteredDisplays =
                    filterSeasonalMerchandiseProductsByVariantDisplays(
                        transformedDataWithFormattedPrices.displays,
                        paramsLocale
                    )
                return {
                    ...transformedDataWithFormattedPrices,
                    displays: filteredDisplays
                }
            }

            return transformedDataWithFormattedPrices
        })
        .with({ success: false }, ({ error }) => {
            logger.error("Error fetching products from Depict", error)

            return null
        })
        .exhaustive()
}
